import React, { useEffect, useMemo, useRef } from "react";
import {
  InputAdornment,
  CircularProgress,
  IconButton,
  FormControl,
  InputLabel,
  FormHelperText
} from "@material-ui/core";
import { textContent } from "@codeArt/utils/dom";
import { empty, equals, invalid, removeAt, type, valid } from "@codeArt/utils/common";
import { runtime } from "@codeArt/common";
import { LoadingSlim } from "../Loading";
import { fetchError } from "redux/actions";
import { getNotificationMessage } from "../common";
import { Request } from "@codeArt/request";
import { alpha, makeStyles } from "@material-ui/core/styles";
import { helpStyle } from "./common";
import { Principal } from "@codeArt/auth";
import { get as objectGet, set as objectSet, deleteValue as objectDeleteValue } from "@codeArt/utils/object";
import { indexOf } from "@codeArt/utils/array";

const _ = require("lodash");

let validateHandles = [
  requiredHandle,
  valueRangeHandle,
  lengthHandle,
  variableHandle
];

//所有的Input组件，确保set时，是不会触发change事件的
//要触发并且赋值请调用handleChange方法
export class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      help: null,
      error: null
    };
    // this._reset=false;
    this.oneIgnores = {}; //忽略一次的配置
  }


  oneIgnore(key){
    this.oneIgnores[key] = true;
  }

  tryOneIgnore(key,action){
    if(this.oneIgnores[key]){
      //忽略一次
      delete this.oneIgnores[key];
      return;
    }
    action(); //不忽略
  }

  get() {
    return this.props.value;
  }

  set(v) {
    this.handleChange(v);
  }

  getLabelText() {
    let { label, title } = this.props;
    if (label) return label;
    if (title) return textContent(title);
    return "";
  }

  tipComponent(componentType, labelSetting) {
    labelSetting = labelSetting || {};
    let { ignore, fixed } = labelSetting;
    let { label, title, required } = this.props;
    if (title)
      return (
        <div
          className={`c-input-title mb-2 ${required
            ? "c-input-required"
            : ""} c-${componentType}-title`}
        >
          {title}
        </div>
      );
    if (!ignore)
      return label ? (
        <InputLabel
          shrink={true}
          required={required}
          className={`c-input-label ${fixed
            ? "c-input-label-fixed"
            : ""} c-${componentType}-label`}
        >
          {label}
        </InputLabel>
      ) : null;
  }

  getClassName(baseClassName) {
    baseClassName = baseClassName || "";
    let { className, size, variant } = this.props;
    className = className || "";
    return `c-input ${variant ? `c-input-${variant}` : ""} ${size
      ? `c-input-${size}`
      : ""} ${baseClassName} c-mb-4d5 ${className}`;
  }

  help(msg) {
    if (invalid(msg)) return this.state.help || this.props.help;
    else {
      this.setState({ help: msg });
    }
  }


  checkEditable() {
    let { editable } = this.props;
    if (!editable) return;

    this.setDisable("正在验证访问权限");
    Principal.verify(editable).then((result) => {
      if (result.allow) this.disable(false);
      else this.setDisable("没有编辑权限");
    }).catch((e) => {
      throw e;
    });
  }

  disabled(b) {
    if (invalid(b))
      return invalid(this.state.disabled)
        ? this.props.disabled
        : this.state.disabled;
    this.setState({
      disabled: b
    });
  }

  readOnly(b){
    if (invalid(b))
      return invalid(this.state.readOnly)
        ? this.props.readOnly
        : this.state.readOnly;
    this.setState({
      readOnly: b
    });
  }

  field() {
    return this.props.field;
  }

  ignoreRecord() {
    return this.props.ignoreRecord;
  }

  getInputProps() {
    let { start, end } = this.props;
    let p = {};
    if (end) {
      p.endAdornment = <InputAdornment position="end">{end}</InputAdornment>;
    }
    if (start) {
      p.startAdornment = (
        <InputAdornment position="start">{start}</InputAdornment>
      );
    }
    return p;
  }

  getValidateHandles() {
    return validateHandles;
  }

  validate(v) {
    //常规的验证
    this.setState({ error: null });
    let value = this.getValidateValue(v); //获得需要验证的值
    let handlers = this.getValidateHandles();
    for (let i = 0; i < handlers.length; i++) {
      let e = handlers[i](this, value);
      if (e) {
        this.setState({ error: e });
        return e;
      }
    }

    if (this.props.validate) {
      let e = this.props.validate(value);
      if (e) {
        this.setState({ error: e });
        return e;
      }
    }
  }

  getValidateValue(v) {
    return invalid(v) ? this.get() : v;
  }

  resetValidate() {
    // this._reset = true;
    this.setState({ error: null });
  }

  defaultErrorMessage(type) {
    switch (type) {
      case "required":
        return `${this.call()}必填`;
      case "min": {
        let { min } = this.props;
        return `${this.call()}不能小于${min}`;
      }
      case "max": {
        let { max } = this.props;
        return `${this.call()}不能大于${max}`;
      }
      default:
    }
  }

  errorMessage(type) {
    let { errorMessage } = this.props;
    if (errorMessage && errorMessage[type]) {
      return errorMessage[type];
    }
    let msg = this.defaultErrorMessage(type);
    if (msg) return msg;
    throw new Error("未能获得错误" + type + "的提示");
  }

  reset() {
    this.resetValidate();
  }

  _renderHelp(content) {
    let { href } = this.props;
    return href ? (
      <div className="d-flex flex-row justify-content-start align-items-center">
        {/* <Link href={href}>{content}</Link><HelpLink className="ml-2" size="sm" href={href} /> */}
        {/* todo */}
        {/* <HelpLink className="mr-1 mt-2" size="sm" href={href} />{content} */}
      </div>
    ) : (
      content
    );
  }

  renderHelp(help, className) {
    if (!help) return null;
    if (type(help) === "string")
      return this._renderHelp(
        <HelperText
          className={`c-input-help ${className || ""}`}
          dangerouslySetInnerHTML={{ __html: help }}
        />
      );
    return this._renderHelp(help);
  }

  disable(b) {
    this.setState({ disabled: b });
  }

  setDisable(disabledTip) { //设置为禁用
    if (invalid(disabledTip)) this.disable(true);
    else this.setState({ disabled: true, disabledTip });
  }

  getDisabled() {
    let { disabled } = this.state;
    if (disabled === true || disabled === false) return disabled;
    return this.props.disabled;
  }

  getTip() {
    let disabledTip = this.state.disabledTip || this.props.disabledTip;
    if (this.getDisabled() && disabledTip) return disabledTip;
    return this.props.tip;
  }

  call() {
    let { label, call } = this.props;
    return call || label || "";
  }

  inputFocus() {
    //判定是否有输入焦点
    let active = document.activeElement;
    if (active.tagName === "BODY") return false;
    let self = this.getReceiveFocus ? this.getReceiveFocus() : null;
    if (!self) return false;
    let p = active;
    while (p) {
      if (p === self) return true;
      p = p.parentElement;
    }
    return false;
  }

  handleChange(v) {
    //基类调用
    let { handleChange, onChange,value } = this.props;
    if(v==value) return;
    this.validate(v);
    //由props的处理触发，不再这里触发，以免二次触发

    if (handleChange) handleChange(v); //注意，属性里传来的handleChange，就是useForm生成的，这里是给redux机制使用的
    this.tryOneIgnore("onChange",()=>{
      if (onChange) onChange(v, { focus: this.inputFocus() }); //当值改变时，组件是否获得了焦点
    }); 
  }
  
  componentDidMount() {
    let { joinForm } = this.props;

    if (joinForm) {
      joinForm(this);
    }

    this.checkEditable();
  }

  componentWillUnmount() {
    let { leaveForm } = this.props;
    if (leaveForm) {
      leaveForm(this);
    }
  }

  componentWillReceiveProps(nextProps) {
    let newValue = nextProps.value;
    let oldValue = this.props.value;
    if (!equals(oldValue, newValue)) {
      if (valid(newValue)) {
        this.set(newValue);
      } else {
        this.reset();
      }
    }
  }
}

const useStyles = makeStyles(theme => ({
  inputHelper: props => ({
    ...helpStyle
  })
}));

const HelperText = props => {
  const classes = useStyles();
  const className = props.className || "";
  return (
    <FormHelperText
      {...props}
      className={`${classes.inputHelper} ${className}`}
    />
  );
};

export function requiredHandle(o, v) {
  let { required, trim } = o.props;
  if (type(v) === "string") {
    if (
      trim !== false //除非指定了不过滤收尾空格，否则默认情况下要过滤
    )
      v = _.trim(v);
  }
  if (required && empty(v)) {
    return o.errorMessage("required");
  }
}

function valueRangeHandle(o, v) {
  let { max, min } = o.props;
  if (empty(v)) return;
  if (!empty(min) && v < min) return o.errorMessage("min");
  if (!empty(max) && v > max) return o.errorMessage("max");
}

function lengthHandle(o, v) {
  let { minlength, maxlength } = o.props;
  if (empty(v)) return;
  if (!empty(minlength) && v.length < minlength)
    return o.errorMessage("minlength");
  if (!empty(maxlength) && v.length > maxlength)
    return o.errorMessage("maxlength");
}

function variableHandle(o, v) {
  if (empty(v)) return;
  let { variable } = o.props;

  if (variable) {
    let reg = /^[0-9a-zA-Z_]{1,}$/;
    if (!reg.test(v)) return o.errorMessage("variable");
  }
}

function selectionRequiredHandle(o, v) {
  let value, fill;
  if (v && !invalid(v.value)) {
    value = v.value;
    fill = v.fill;
  } else value = v;

  let error = requiredHandle(o, type(value) === "object" ? value.value : value);
  if (error) return error;

  let { options } = o.props;
  if (empty(options) || empty(value)) return null;
  let call = o.call();

  options.forEach(t => {
    if (t.value === value && t.fill) {
      let { required, minlength, maxlength, trim } = t.fill;

      let localFill = fill;
      if (type(localFill) === "string") {
        if (
          trim !== false //除非指定了不过滤首尾空格，否则默认情况下要过滤
        )
          localFill = _.trim(localFill);
      }
      if (required && empty(localFill)) {
        error = `${call}的填空必填`;
      } else if (maxlength && localFill.length > maxlength) {
        error = `${call}的填空字数不能大于${maxlength}`;
      } else if (minlength && localFill.length < minlength) {
        error = `${call}的填空字数不能小于${minlength}`;
      }
    }
  });

  return error;
}

export class Selection extends Input {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state
    };
  }

  getValidateHandles() {
    return [...validateHandles, selectionRequiredHandle];
  }

  options(l, cb) {
    if (l) {
      this.__options = l;
      this.setState({ options: l }, () => {
        if (cb) cb();
      });
    } else {
      if (!empty(this.__options)) return this.__options;
      if (!empty(this.state.options)) return this.state.options;
      if (!empty(this.props.options)) return this.props.options;
      return [];
    }
  }

  addOptions(l) {
    let items = this.options();
    l.forEach(t => {
      let i = indexOf(items, item => item.value === t.value);
      if (i > -1) removeAt(items, i);
      items.push(t);
    });
    this.options(items);
  }

  reset() {
    this.handleChange();
    this.resetValidate();
  }

  defaultErrorMessage(type) {
    let { minlength, maxlength } = this.props;
    let label = this.call();
    switch (type) {
      case "required":
        return `请选择${label}`;
      case "minlength": {
        return `${label}选择的数量不能小于${minlength}`;
      }
      case "maxlength": {
        return `${label}选择的数量不能大于${maxlength}`;
      }
      default:
    }
    return super.defaultErrorMessage(type);
  }

  getOptionHelp(value) {
    let options = this.options();
    if (invalid(value)) return;
    let l = options.filter(p => p.value === value);
    if (l.length > 0 && l[0].help) return l[0].help;
  }

  renderInput() { }

  renderLoading() {
    let { className } = this.props;
    return (
      <LoadingSlim className={`c-mh2 ${className}`} size="xs" message="加载中" />
    );
  }

  renderMain() {
    let { mobileable } = this.props;
    if (runtime.mobile && mobileable) return this.renderMobile();

    let { error } = this.state;
    let help = this.help();
    let labelSetting = this.labelSetting || {};
    let { variant, width, minWidth, maxWidth, size, margin } = this.props;
    let style = { width, minWidth, maxWidth };
    return (
      <FormControl
        size={size}
        data-gta-container
        data-gta-title={this.getLabelText()}
        variant={variant}
        style={style}
        margin={margin}
        className={`${this.getClassName(
          `${width || minWidth || maxWidth ? "" : "w-100"} ${this
            .baseClassName || ""}`
        )} c-selection`}
        error={error ? true : false}
        disabled={this.getDisabled()}
      >
        {this.tipComponent("selection", labelSetting)}
        {this.renderInput()}
        {this.renderHelp(error || help)}
      </FormControl>
    );
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadOptions();
  }

  getLoad() {
    let { load } = this.props;
    if (!load) return;
    return type(load) === "function" ? load() : load;
  }

  loadOptions() {
    let load = this.getLoad();
    if (!load) return;
    let my = this;
    let { onLoadOptions } = my.props;

    if (type(load) === "array") {
      //直接返回了选项集合
      let options = load;
      my.loadOptionsEnd(options, () => {
        if (onLoadOptions) onLoadOptions(options);
      });
      return;
    }
    Request.mute({
      ...load,
      url: load.url || load.action,
      success: r => {
        let options = r.rows || r.items;
        my.loadOptionsEnd(options, () => {
          if (load.onload) load.onload(options);
          if (onLoadOptions) onLoadOptions(options);
        });
      }
    });
  }

  loadOptionsEnd(options, cb) {
    this.options(options, () => {
      this.setState(
        {
          loading: false
        },
        () => {
          let value = this.get();
          if (!invalid(value)) {
            this.handleChange(value);
          }
          if (cb) cb();
        }
      );
    });
  }

  refresh() {
    let my = this;
    my.setState(
      {
        loading: true
      },
      () => {
        my.loadOptions();
      }
    );
  }

  render() {
    let load = this.getLoad();
    if (!load) return this.renderMain();
    return this.state.loading === false
      ? this.renderMain()
      : this.renderLoading();
  }
}

export function combineEvent(c0, c1) {
  //c0,c1是用于响应事件的函数
  if (c0 && !c1) return c0;
  if (!c0 && c1) return c1;
  if (!c0 && !c1) return null;
  return function () {
    //这里不能用()=> 因为会将arguments记录为c0,c1
    var args = arguments;
    c0.apply(this, args);
    c1.apply(this, args);
  };
}

function getValue(data, n) {
  for (let e in data) {
    if (e.toLocaleLowerCase() === n.toLocaleLowerCase()) return data[e];
  }
}

export const useForm = ({
  data,
  dispatch,
  setData,
  redux,
  record,
  onChange,
  process, //get之前，会用process处理数据，方便转换
  verify, // 接受外部送过来的验证要求，一般是独立控件的验证结果
  notice = true
}) => {
  //redux指示数据是否来自redux
  let form = useMemo(
    () => new Form({ data, dispatch, setData, redux, record, onChange, notice, process, validate: verify }),
    [dispatch, setData]
  ); //使用了useMemo才会缓存form，否则每次渲染都会创建一个新的form

  const input = (field, config = {}) => {
    return form.addInput(field, config);
  };

  const submit = arg => {
    return form.submit(arg);
  };

  const get = (field) => {
    return form.get(field);
  };

  const set = (data, b) => {
    return form.set(data, b);
  };

  const accept = data => {
    return form.accept(data);
  };

  const reset = () => {
    return form.reset();
  };

  const validate = v => {
    return form.validate(v);
  };

  return { input, submit, get, set, reset, accept, validate };
};

useForm.getInputProps = (props) =>{ //从属性中，提取由form给予的属性，这在写嵌入式组件时很有用
  const {value,handleChange,joinForm,leaveForm} = props;
  return {value,handleChange,joinForm,leaveForm};
}

function Form({
  data,
  dispatch,
  record,
  notice,
  setData,
  validate,
  redux,
  onChange,
  process
}) {
  //validate自定义验证
  let _inputs = [];
  let _configs = {};

  this.addInput = (field, config) => {
    let props = { field };
    let value = objectGet(data, field);
    // if (!invalid(value))
    props.value = value;

    props.handleChange = v => {
      //向属性中写入handleChange方法，该方法会在内部change时调用
      update(data => {
        objectSet(data, field, v);
      });
      if (onChange) onChange(data);
    };

    props.joinForm = input => {
      _inputs.push(input);
      /* _configs[field] = config; */
      objectSet(_configs, field, config);
    };

    props.leaveForm = input => {
      _.remove(_inputs, p => p === input);
      /*  delete _configs[field];  */
      objectDeleteValue(_configs, field);
    };

    return props;
  };

  const update = (action, clear) => {
    //必须调用该方法来更新数据，不然更新失效
    data = clear ? {} : { ...data }; //关键在于这个句话，data=...，必须修改data，如果用其他的局部变量写入，是无法更新的
    action(data);
    if (redux) dispatch(setData(data));
    else setData(data); //设置本地数据
    return data;
  };

  const getConfig = n => {
    return objectGet(_configs, n) || {};
  };

  //#region  验证

  this.validate = targetData => {
    //可以传递指定的targetData，来验证数据是否合法
    let errors = _validate(targetData);
    //自定义验证
    if (validate) {
      let es = validate();
      if (es) {
        if (type(es) === "array") {
          errors = errors.concat(es);
        } else {
          errors.push(es);
        }
      }
    }

    if (errors.length > 0) {
      let error = getNotificationMessage(errors);
      if (notice) dispatch(fetchError(error));
      return errors;
    }
  };

  const _validate = targetData => {
    let errors = [];
    if (!targetData) {
      //验证内部组件的值
      _inputs.forEach(p => {
        p = p.current || p;
        if (p.validate) {
          let e = p.validate();
          if (e) {
            if (type(e) === "array") {
              errors = errors.concat(e);
            } else {
              errors.push(e);
            }
          }
          //if (e) errors.push(e);
        }
      });
    } else {
      //验证传递来的值
      _inputs.forEach(p => {
        p = p.current || p;
        if (p.validate) {
          let n = p.field();
          let v = getValue(targetData, n);
          let e = p.validate(v);
          if (e) errors.push(e);
        }
      });
    }

    return errors;
  };

  //#endregion

  //#region  记忆

  let _recordData = record ? _.cloneDeep(data) : null;

  const updateRecord = d => {
    _recordData = _.cloneDeep(d);
  };

  const getChangedData = () => {
    //在record模式下，获取改变了的值
    let temp = {};
    _.forIn(data, (value, key) => {
      let config = getConfig(key);
      if (
        config.ignoreRecord ||
        JSON.stringify(value) !== JSON.stringify(objectGet(_recordData, key))
      ) {    
      /*   temp[key] = data[key]; */
        let v = objectGet(data, key);
        objectSet(temp, key, v);
      }
    });

    return temp;
  };

  //#endregion

  const _get = () => {
    if (record) return getChangedData();
    return { ...data };
  }

  this.get = (field) => {
    if(field) return data[field];
    let value = _get();
    return process ? process(value) : value;
  };

  this.change = d => {
    data = update(data => {
      for (let e in d) {
        let v = objectGet(d, e);
        objectSet(data, e, v);
      }
    });

    if (record) updateRecord(data);
  };

  this.set = d => {
    this.change(d);
  };

  this.accept = d => {
    data = update(data => {
      _.forIn(d, (value, key) => {
        objectSet(data, key, value);
      });
    }, true); //清空后再修改

    if (record) updateRecord(data);
  };

  this.reset = () => {
    data = update(data => {
      _inputs.forEach(input => {
        let field = input.field();
        let config = getConfig(field);
        /*  if (config.defaultValue) data[field] = config.defaultValue; */
        if (config.defaultValue) objectSet(data, field, config.defaultValue);
      });
    }, true); //清空后再修改

    if (record) updateRecord(data);
  };

  this.submit = async arg => {
    let e = this.validate();
    if (e) return;

    if(arg.validate){
      //submit传递的参数有验证方法
      let r = await arg.validate();
      if(r==false) return;
    }

    let _data = { ...this.get(), ...arg.data };
    if (arg.process) {
      _data = arg.process(_data);
      delete arg.process;
    }

    arg.success = combineEvent(arg.success, () => {
      if (record) updateRecord(data);
    });

    Request(
      {
        ...arg,
        data: _data
      },
      dispatch
    );
  };
}
